import { videoTitles as titlesEn } from './videoTitles.en';
import { videoTitles as titlesRu } from './videoTitles.ru';
import * as React from 'react';
import { YouTube } from './YouTube';
import './ResponsiveVideo.css';

// MDX component for `<ResponsiveVideo portraitYouTubeId="…" landscapeYouTubeId="…" titleKey="…" lang="en|ru" />`.
// Two YouTube embeds (founder Q-art-yt-1, 2026-10-04: extra views for the channel): the vertical Short on phones
// (< 700 px), the 16:9 video on wider screens. The accessible title comes from videoTitles.{en,ru}.ts by key
// (the RU is generated by gen-ru-gemini — never hand-written).
// SSR-safe: the server renders two empty, correctly sized frames; after mount a matchMedia check renders ONLY the
// matching player, so the hidden one never creates an iframe (no request) and follows a resize / rotation.
type Props = {
  portraitYouTubeId: string;
  landscapeYouTubeId: string;
  titleKey: keyof typeof titlesEn;
  lang?: 'en' | 'ru';
};

const QUERY = '(min-width: 700px)';

export const ResponsiveVideo = ({ portraitYouTubeId, landscapeYouTubeId, titleKey, lang = 'en' }: Props) => {
  const title = (lang === 'ru' ? titlesRu : titlesEn)[titleKey];
  const [wide, setWide] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const update = () => setWide(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return (
    <figure className="cc-rv">
      <div className="cc-rv__portrait">
        {wide === false && (
          <YouTube youTubeId={portraitYouTubeId} title={title} aspectRatio="9 / 16" maxWidth={360} />
        )}
      </div>
      <div className="cc-rv__landscape">
        {wide === true && <YouTube youTubeId={landscapeYouTubeId} title={title} />}
      </div>
      {wide === null && (
        <noscript>
          <YouTube youTubeId={landscapeYouTubeId} title={title} />
        </noscript>
      )}
    </figure>
  );
};

export default ResponsiveVideo;
